export function dateToTimestamp(dateString: string): number {
  var dateObj = new Date(dateString);

  var timestamp = dateObj.getTime();

  return Math.floor(timestamp / 1000);
}
